<template>
  <div class="shipping">
    <div class="actions flex flex-col md:flex-row justify-between">
      <div class="action-left mb-2 md:mb-0 md:mr-4">
        <h2 class="text-xl md:text-left">Shipping Schedule</h2>
      </div>

      <div class="search flex items-center md:ml-4">
        <button class="btn btn-main" @click="handleNewEntry">New Entry</button>
        <input
          type="text"
          placeholder="Search"
          v-model="search"
          class="input-search ml-2"
          @keyup="handleSearchChange"
        />
      </div>
    </div>
    <ShippingEditor
      v-if="showEditor"
      :editId="editId"
      :editData="editData"
      @overlayClick="handleOverlayClick"
      @recordCreated="handleRecordCreated"
      @recordUpdated="closeOverlay"
      @recordDeleted="closeOverlay"
    ></ShippingEditor>
    <div class="grid-wrap" style="height: calc(100vh - 172px)">
      <ag-grid-vue
        style="width: 100%; height: 100%"
        class="ag-theme-alpine ag-theme-capitol"
        :getRowId="(params) => params.data.id"
        :columnDefs="columnDefs"
        :rowData="shipping"
        :defaultColDef="defaultColDef"
        :getContextMenuItems="getContextMenuItems"
        :suppressColumnMoveAnimation="true"
        :statusBar="{
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left',
            },
          ],
        }"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "../../lib/ag-grid-enterprise";
import { AgGridVue } from "ag-grid-vue";
import { db } from "../database/db.js";
import ShippingEditor from "@/components/ShippingEditor.vue";
import { dateColumn } from "@/utils/columns";

const defaultColDef = {
  flex: 1,
  editable: false,
  sortable: true,
  resizable: true,
  wrapText: true,
  wrapHeaderText: true,
  width: 140,
  enableCellChangeFlash: true,
};

export default {
  name: "App",
  data() {
    return {
      search: "",
      shipping: [],
      columnDefs: null,
      defaultColDef,
      gridApi: null,
      columnApi: null,
      showEditor: false,
      editId: null,
      editData: null,
    };
  },
  components: {
    AgGridVue,
    ShippingEditor,
  },
  created() {
    let time1 = new Date(new Date().setDate(new Date().getDate() - 7));
    this.$bind(
      "shipping",
      db.collection("shipping").where("ship_date", ">", time1)
    )
      .then((shipping) => {
        this.shipping = shipping;
      })
      .catch((e) => {
        if (e.message.includes("insufficient permissions")) {
          this.$toasted.show("Insufficient Permissions", {
            type: "error",
            theme: "bubble",
            position: "bottom-center",
            duration: 3000,
          });
        }
      });
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      this.gridColumnApi.applyColumnState({
        state: [{ colId: "ship_date", sort: "desc" }],
        defaultState: { sort: null },
      });
      setTimeout(() => {
        // params.api.sizeColumnsToFit();
      }, 50);
    },
    handleNewEntry() {
      this.editId = null;
      this.editData = null;
      this.showEditor = true;
    },
    handleOverlayClick() {
      this.showEditor = false;
    },
    handleRecordCreated(id) {
      this.showEditor = false;
      var rowNode1 = this.gridApi.getRowNode(id);
      this.gridApi.flashCells({
        rowNodes: [rowNode1],
      });
      // this.gridApi.sizeColumnsToFit();
    },
    closeOverlay() {
      this.showEditor = false;
    },
    handleSearchChange(e) {
      this.gridApi.setQuickFilter(this.search);
    },
    getContextMenuItems(params) {
      var result = [
        {
          name: "Edit Record",
          action: () => {
            this.showEditor = true;
            this.editId = params.node.id;
            this.editData = params.node.data;
          },
        },
        {
          name: "Clone Record",
          action: () => {
            this.showEditor = true;
            this.editId = null;
            this.editData = params.node.data;
          },
        },
      ];
      return result;
    },
  },
  beforeMount() {
    this.columnDefs = [
      dateColumn("ship_date", "Ship Date"),
      { field: "lot_num", headerName: "Lot No", minWidth: 80 },
      { field: "customer", autoHeight: true, minWidth: 80 },
      { field: "head_in", headerName: "Head In", minWidth: 80 },
      { field: "avg_wt_in", headerName: "Avg Wt In", minWidth: 80 },
      { field: "type", minWidth: 80 },
      { field: "pasture", autoHeight: true, minWidth: 80 },
      { field: "destination", autoHeight: true, minWidth: 80 },
      {
        field: "arrival_instructions",
        headerName: "Arrival Instructions",
        minWidth: 80,
      },
      { field: "truck_info", headerName: "Truck Info", minWidth: 80 },
      { field: "deads", minWidth: 80 },
      { field: "pi", headerName: "PI", minWidth: 80 },
      { field: "remarks", minWidth: 80 },
    ];
  },
};
</script>
